import { planTypes } from '@/common/constants';

export default {
  data() {
    return {
      logo: require('@/assets/plans/logo_zoom_custom_ai_companion.svg'),
      title: this.$t('billing.zoom_custom_ai_companion.title'),
      planType: planTypes.ZOOM_CUSTOM_AI_COMPANION,
      description: this.$t('billing.zoom_custom_ai_companion.desc'),
    };
  },
};
